import React from 'react';
import { skills } from '../../data/portfolio';
import { useScrollReveal } from '../../hooks/useScrollReveal';
import SectionHeader from '../SectionHeader/SectionHeader';
import './SkillsMarquee.css';

const half = Math.ceil(skills.length / 2);
const rowOne = skills.slice(0, half);
const rowTwo = skills.slice(half);

function MarqueeRow({ items, direction = 'left' }) {
  const doubled = [...items, ...items];

  return (
    <div className={`marquee marquee--${direction}`}>
      <div className="marquee__track">
        {doubled.map((skill, i) => {
          const Icon = skill.icon;
          return (
            <div className="marquee__chip" key={`${skill.name}-${i}`}>
              <Icon className="marquee__chip-icon" />
              <span className="marquee__chip-name">{skill.name}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function SkillsMarquee() {
  const [ref, visible] = useScrollReveal(0.2);

  return (
    <section className="skills-marquee section" id="skills">
      <div className="container">
        <SectionHeader title="Skills & Technologies" subtitle="My technical toolkit" />
      </div>

      <div ref={ref} className={`skills-marquee__rows ${visible ? 'skills-marquee__rows--visible' : ''}`}>
        <MarqueeRow items={rowOne} direction="left" />
        <MarqueeRow items={rowTwo} direction="right" />
      </div>
    </section>
  );
}

export default SkillsMarquee;
